export default __webpack_public_path__ + "static/media/logo.bf82bc32.svg";